Ext.define('SA.view.manageproject.ViewsList', {
    alias: 'widget.manage-project-views-list',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-manage-project-view-list',

    layout: {
        type: 'vbox',
        align: 'stretch'
    },

    plugins: [
        {
            ptype: 'sa-animation',
            size: false
        }, {
            ptype: 'sa-drag-reorder',

            itemDragCls: 'sa-manage-project-view-list-item-drag',
            itemSelector: '.sa-manage-project-view-list-item',

            afterMove(oldIndex, newIndex) {
                var list = this.cmp,
                    project = list.project;

                list.getPlugin('sa-animation').clear();

                project.moveView(oldIndex, newIndex);

                project.save();
            }
        }
    ],

    saAnim: {
        add: false,
        hide: false,
        position: false,
        show: false,
        size: 'height'
    },

    refresh() {
        var oldItems = this.query('> *'),
            newItems = [];

        this.project.getViews().forEach(view => {
            var index = oldItems.findIndex(item => item.projectView === view),
                entry = index === -1 ? null : oldItems.splice(index, 1)[0];

            if (entry) {
                entry.refresh();
            }
            else {
                entry = {
                    xtype: 'manage-project-views-list-item',
                    projectView: view
                };
            }

            newItems.push(entry);
        });

        oldItems.forEach(item => {
            if (item.hideTime) {
                if (item.hideTime < new Date() - 5000) {
                    item.destroy();
                }
            }
            else {
                item.hide();
                item.hideTime = +new Date();
            }
        });

        this.insert(0, newItems);

        this.getPlugin('sa-animation').resetStyles();

        this.fireEvent('afterlayout');

        setTimeout(() => {
            var items = this.query('> {isVisible()}');

            items.forEach((item, index) => {
                item.ifCls(index % 2 === 1, 'sa-manage-project-view-list-item-alt');
            });
        }, 10);
    }
});
